import getAllQueryParams from 'utils/getAllParamsFromURL';

const facetsMapper = (aggregations) => {
  const activeQueryParams = getAllQueryParams();
  const refinementList = activeQueryParams?.refinementList || {};
  const result = {};

  Object.keys(aggregations).forEach((key) => {
    const cleanKey = key.replace('_facet', '');
    const refinedValues = refinementList[cleanKey] || [];

    result[cleanKey] = aggregations[key].buckets.map((el) => ({
      isRefined: refinedValues.includes(el.key),
      label: el.key,
      value: [el.key],
    }));
  });

  return result;
};

export default facetsMapper;
